import React from "react";
import Item from "./Item";
import { motion } from "framer-motion";
import { Accordion } from "../../nq-component";
import { item } from "../../utils/animationUtils";

function Child({ menu, onClick }) {
  const { name, icon, label, route, id } = menu;
  let key = id || label || name.replaceAll(" ", "");
  return (
    <React.Fragment key={key}>
      <motion.li variants={item} className="nav-item w-100">
        <Accordion
          eventKey={key}
          className="nav-link font-size-sm text-truncate"
        >
          <div className="d-inline">
            <i className={`${icon} text-secondary`}></i>
            <span className="ms-2 text-primary fw-medium">{label || name}</span>
          </div>
          <div className="float-end">
            <i className="bi bi-chevron-down"></i>
          </div>
        </Accordion>
      </motion.li>
      <Accordion.Collapse eventKey={key}>
        <ul className="navbar-nav ms-4">
          {route.map((m, i) => {
            return <Item menu={m} onClick={onClick} />;
          })}
        </ul>
      </Accordion.Collapse>
    </React.Fragment>
  );
}

export default Child;
